import { cloneDeep, filter } from 'lodash'
import moment from 'moment'
import { apiAssetUrl } from 'utils'

export default {
  computed: {
    /**
     * Check if the thread is just between users and admin - no link between client and talent/manager
     */
    adminThread () {
      if (filter(cloneDeep(this.thread.participants), current => (current.role === 'client')).length > 0 &&
            (filter(cloneDeep(this.thread.participants), current => (current.role === 'talent')).length > 0 ||
            filter(cloneDeep(this.thread.participants), current => (current.role === 'manager')).length > 0)) {
        return false
      }
      return true
    },

    /**
     *
     */
    threadButton () {
      let participants = filter(cloneDeep(this.thread.participants), current => (!this.$checkUserIsAdmin(current) && current.id !== this.$user.id))
      if (this.$userIsClient || this.$userIsTalent || this.$userIsManager) {
        if (participants.length > 0) {
          return 'Message Group'
        }
        return 'Message'
      }
      if (this.$userIsAdmin) {
        return 'Open Chat'
      }
    },

    /**
     * Show the names of all of the thread participants
     */
    participantsNames () {
      let participants = filter(cloneDeep(this.thread.participants), current => (!this.$checkUserIsAdmin(current) && current.id !== this.$user.id))
      if (participants.length) {
        let participantNamesLabel = (participants.map(p => p.name + ' (' + this.$t(p.role) + ')').join(', '))
        return this.$userIsAdmin ? participantNamesLabel : participantNamesLabel + ', ' + this.clientName.toUpperCase() + ' Admin'
      }
      return this.clientName + ' Admin'
    },

    participantsAvatars () {
      let defaultImage = this.clientName.toLowerCase() === 'pickstar' ? '/img/pickstar-avatar-128.png' : '/img/profile-default.jpg'
      let participants = filter(cloneDeep(this.thread.participants), current => (!this.$checkUserIsAdmin(current) && current.id !== this.$user.id))
      let avatars = []
      if (participants.length) {
        avatars = participants.map((p) => {
          return {id: p.id, avatar: p.avatar, name: p.name}
        })
      }
      avatars.push({id: 0, avatar: defaultImage, name: this.clientName + ' Admin'})
      return avatars
    },

    messageTimestamp () {
      if (this.thread.latest_message) {
        let message = this.thread.latest_message
        // if it was today - then display in hour format
        if (moment().year() === moment.utc(message.created_at).year() &&
          moment().month() === moment.utc(message.created_at).month() &&
          moment().day() === moment.utc(message.created_at).day()) {
          return moment.utc(message.created_at).tz(this.$user.timezone).format('h:mm a')
        } else if (moment().year() === moment.utc(message.created_at).year()) {
          // if it was in the past year, then display in day month
          return moment.utc(message.created_at).tz(this.$user.timezone).format(this.$user.date_format_preference === 'day-first' ? 'D MMM' : 'MMM D')
        } else {
          // else display it in day month year
          return moment.utc(message.created_at).tz(this.$user.timezone).format(this.$user.date_format_preference === 'day-first' ? 'D MMM YY' : 'MMM D YY')
        }
      }
    },

    messageName () {
      if (this.thread.latest_message) {
        if (this.$user.id === this.thread.latest_message.user.id) {
          return 'You'
        }
        return this.thread.latest_message.user.name
      }
      return ''
    }
  }
}
